import OBSERVATION_REPORT_RESULTS from './observationReportResults';

const OBSERVATION_REPORT_RESULT_MAP = new Map([
  [OBSERVATION_REPORT_RESULTS.PASS, 'Pass'],
  [OBSERVATION_REPORT_RESULTS.FAIL, 'Fail'],
  [OBSERVATION_REPORT_RESULTS.COACHING, 'Coaching']
]);

export default OBSERVATION_REPORT_RESULT_MAP;
